import * as func from './func';

const PATH_DELIMITER = '.';

export const stringToPath = (str) => {
  return func.isString(str) ? str.split(PATH_DELIMITER) : str;
};
